import * as yup from "yup";
import { UserApi } from "../../../apis";

export const schema = (
    t: (val: string) => string,
    isEditMode: boolean = false,
    isStudent: boolean = true
) => {
    const validation = {
        firstName: yup.string().required(t("cmn:val.required")),
        lastName: yup.string().required(t("cmn:val.required")),
        zipCode: yup
            .string()
            .nullable()
            .test("valid-zip", t("cmn:val.zipCode"), (value) => {
                if (!value) return true;
                return /^[A-Za-z0-9\s-]{3,10}$/.test(value);
            }),
    };
    if (isStudent) {
        validation["training"] = yup.string().required(t("cmn:val.required"));
        validation["trainingYear"] = yup
            .string()
            .required(t("cmn:val.required"));
    }
    if (!isEditMode) {
        validation["email"] = yup
            .string()
            .required(t("cmn:val.required"))
            .email(t("ent.User:email.val.email"))
            .test("isExist", t("ent.User:email.val.uniq"), async (value) => {
                return (
                    (
                        await UserApi.postUserExist<
                            { isExist: boolean },
                            { email: string }
                        >({
                            email: value,
                        })
                    ).response?.isExist !== true
                );
            });
    }
    return yup.object().shape({ ...validation });
};
